module.exports = __webpack_public_path__ + "static/media/correct.0b5bc360.gif";